const About = () => {
  return (
    <div className="about">
      <div className="container">
        <h1>About Us</h1>
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsa dicta aliquid nihil odit corrupti
          illum nam exercitationem praesentium autem, consequatur unde debitis, id nobis iste? Ducimus, quis
          alias est deleniti dolorum illum at, enim nostrum quidem, sunt vero modi fugiat.
        </p>
      </div>
    </div>
  );
};
export default About;
